import { Box, Chip, Grid } from "@mui/material";
import CustomText from "../components/CustomText";
import FormDoctorsDirectory from "../components/FormDoctorsDirectory";

const DoctorsDirectory = () => {
  return (
    <Box sx={design.Background}>
      <Box sx={design.Overlay} />

      <Grid container sx={design.Content}>
        <Chip label="Texcoco, Estado de México" sx={design.Chip} />

        <CustomText variant="body1" sx={design.Subtitle}>
          Atención médica de calidad con tecnología de vanguardia
        </CustomText>

        <CustomText variant="body1" sx={design.Descrip}>
          Donde la familia es
          <br />
          nuestra prioridad
        </CustomText>

        <Box sx={design.Form}>
          <FormDoctorsDirectory />
        </Box>
      </Grid>
    </Box>
  );
};

export default DoctorsDirectory;

const design = {
  Background: {
    position: "relative",
    width: "100%",
    minHeight: { xs: "50vh", sm: "85vh", md: "75vh", lg: "73vh" },
    backgroundImage: `url(https://centromedicomedam.com/IMG/centromedicoMEDAM/Fachada_Medam_Home.png)`,
    backgroundSize: {
      xs: "cover",
      sm: "cover",
      md: "cover",
      lg: "cover",
    },
    backgroundPosition: {
      xs: "center",
      sm: "78% center",
      md: "100% 60%",
      lg: "100% 60%",
      xl: "center 60%",
    },
    overflow: "hidden",
  },
  Overlay: {
    position: "absolute",
    inset: 0,
    background:
      "linear-gradient(-30deg, rgba(120,42,159,.65) 7%, rgba(22,46,132,.75) 100%)",
    zIndex: 1,
  },
  Content: {
    position: "relative",
    zIndex: 2,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    minHeight: {
      xs: "40vh",
      sm: "85vh",
      md: "73vh",
      lg: "83vh",
    },
    px: {
      xs: 1,
      sm: 4,
      md: 6,
      lg: 8,
    },
    py: {
      xs: 3,
      sm: 6,
      md: 0,
    },
  },
  Chip: {
    color: "#FFF",
    border: "1px solid rgba(255,255,255,.45)",
    background: "rgba(255,255,255,.18)",
    backdropFilter: "blur(10px)",
    fontFamily: "Plus Jakarta Sans",
    fontWeight: 600,
    px: { xs: 1, sm: 2, md: 3 },
    py: { xs: 0.4, sm: 0.8 },
    fontSize: { xs: 14, sm: 13, md: 15, lg: 16 },
    mb: { xs: 2, sm: 3 },
  },
  Subtitle: {
    color: "#FFF",
    opacity: 0.95,
    fontFamily: "Plus Jakarta Sans",
    fontWeight: 500,
    maxWidth: { xs: 320, sm: 500, md: 750, lg: 900 },
    fontSize: { xs: 17, sm: 17, md: 22, lg: 26 },
    lineHeight: 1.5,
    mb: { xs: 2, sm: 4, md: 5 },
  },
  Descrip: {
    color: "#FFF",
    fontFamily: "Nunito",
    fontWeight: 800,
    lineHeight: {
      xs: 1.05,
      md: 1,
    },
    letterSpacing: 0,
    maxWidth: { xs: 330, sm: 500, md: 700, lg: 900 },
    fontSize: { xs: 33, sm: 46, md: 60, lg: 72, xl: 80 },
    mt: { xs: 1, sm: 2, md: 4 },
    mb: { xs: 1, sm: 5, md: 4 },
  },
  Form: {
    width: { xs: "100%", sm: "95%", md: "85%", lg: "70%", xl: "100%" },
    maxWidth: 900,
    mt: { xs: 1, sm: 3, md: 4 },
  },
};
